'use strict';

class NoteParser {
  // Using the 'static' keyword creates a method which is associated
  // with a class, but not with an instance of the class.
  static parse(str_contents) {
    let items = str_contents.split(/\r?\n/);
    let parsed_items = [];
    items.forEach(line => {
      const firstChar = line[0];
      const object_found = (firstChar == '{');
      let object_parsed = false;

      if (object_found) {
        try {
          object_parsed = JSON.parse(line);
        } catch (error) {
          object_parsed = false;
        }
      }
      
      if (object_parsed) {
        parsed_items.push(object_parsed);
      } else {
        parsed_items.push({type:"text",value:line});
      }
    });
    return parsed_items;
  }
}

export default NoteParser;


// WEBPACK FOOTER //
// ./src/shared/NoteParser.js